module.exports = __webpack_public_path__ + "videos/14.69c839f.mp4";